import { render, staticRenderFns } from "./SignatureChange.vue?vue&type=template&id=6ffa84a9&"
import script from "./SignatureChange.vue?vue&type=script&lang=js&"
export * from "./SignatureChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports